import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "yes--sprite",
  "use": "yes--sprite-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"yes--sprite\"><path d=\"M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol